<template>
  <el-cascader
    v-model="value"
    :options="options"
    :key="cascaderKey"
    clearable
    filterable
    placeholder="场/楼层"
    expand-trigger="hover"
    @change="handleChange">
  </el-cascader>
</template>

<script>
// TODO change API
import { mapActions, mapGetters } from 'vuex';
import { getPlacesInfo } from '@/api/map';
import eventHub from '@/utils/eventHub';
import { events } from '@/utils/events';

export default {
  model: {
    prop: 'floor',
    event: 'change',
  },
  props: {
    floor: {
      required: true,
    },
  },
  data() {
    return {
      value: [],
      options: [],
      cascaderKey: 0,
      optionsChanged: true,
    };
  },
  computed: {
    floorId() {
      return this.$route.query.floor_id;
    },
    placeId() {
      return this.$route.query.place_id;
    },
    ...mapGetters(['floorInfoInit']),
  },
  watch: {
    floorInfoInit: {
      handler(val) {
        this.cascaderKey += 1;
        this.options = this.format(val);
        this.value = this.formatValue(this.options);
        this.ToggleFloorInfo(this.value);
      },
      deep: true,
    },
    floor: {
      handler(val) {
        this.value = val;
      },
      immediate: true,
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions(['ToggleFloorInfo', 'getFloorInfoInit']),
    getData() {
      // getPlacesInfo().then((res) => {
      this.getFloorInfoInit().then((res) => {
        // this.options = this.format(res.data);
        this.cascaderKey += 1;
        this.options = this.format(this.floorInfoInit);
        this.value = this.formatValue(this.options);
        this.ToggleFloorInfo(this.value);
      });
    },
    formatValue(val) {
      const result = [];
      if (!this.placeId) { return []; }
      const currentPlace = val.find(place => place.value.id === parseInt(this.placeId, 10));
      if (this.floorId && currentPlace) {
        currentPlace.children.forEach((floor) => {
          if (floor.value.id === parseInt(this.floorId, 10)) {
            result.push(currentPlace.value);
            result.push(floor.value);
          }
        });
      }
      // eslint-disable-next-line consistent-return
      return result;
    },
    format(list) {
      if (!list || !list.length) {
        return [];
      }
      const options = [];
      list.forEach((item) => {
        const { floors, ...other } = item;
        const { id: place_id, name } = other;
        let placeOption = options.filter(b => b.value === place_id)[0];
        // 找到对应的brand，若找不到则创建
        if (!placeOption) {
          placeOption = {
            value: other,
            label: name,
          };
          options.push(placeOption);
        }

        if (!placeOption.children) {
          placeOption.children = [];
        }
        if (floors && floors.length > 0) {
          placeOption.children = floors.map(i => ({
            value: i,
            label: i.name,
          }));
        }
      });
      return options;
    },
    handleChange() {
      this.$emit('change', this.value);
    },
    reset() {
      this.value = [];
    },
  },
};
</script>
